<template>
  <div
    v-if="isFlyout"
    class="menu-flyout"
    :class="{'is-open': show}"
    @mouseenter="openFlyout"
    @mouseleave="closeFlyout">
    <div
      class="menu-collapse__item"
      @click.stop="openFlyout">
      <MenuItem
        :class="menuItemClass"
        :data-qa="dataQa"
        :disabled="disabled"
        :icon="icon"
        icon-class="ml-1"
        :icon-color="iconColor ? iconColor : (show? 'var(--text-color)' : 'grey')"
        :label="label"/>
      <sIcon
        class="ml-2 my-auto"
        rotate="90"
        size="10"
        type="arrow"/>
    </div>
    <div
      v-show="show && !disabled"
      class="menu-flyout__submenu">
      <slot
        name="submenu"/>
    </div>
  </div>
  <CollapseBlock
    v-else
    class="menu-collapse"
    :class="{'is-open': show}"
    transparent
    :value="show">
    <div
      slot="title"
      class="menu-collapse__item"
      @click.stop="show = !show">
      <MenuItem
        :class="menuItemClass"
        :data-qa="dataQa"
        :disabled="disabled"
        :icon="icon"
        icon-class="ml-1"
        :icon-color="iconColor ? iconColor : (show? 'var(--text-color)' : 'grey')"
        :label="label"/>
      <sIcon
        class="ml-2 my-auto"
        :rotate="show ? '-180' : '0'"
        size="10"
        type="arrow"/>
    </div>
    <slot
      name="submenu"/>
  </CollapseBlock>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import CollapseBlock from 'components/common/CollapseBlock.vue'
import displaySize from 'mixins/display-size'

// Ширше за планшет — підменю розгортається вбік, вужче — гармошкою
const FLYOUT_MIN_WIDTH = 1025
const FLYOUT_CLOSE_DELAY = 200

export default {
  name: 'MenuItemCollapse',
  mixins: [displaySize],
  data() {
    return {
      show: false
    }
  },
  methods: {
    openFlyout() {
      clearTimeout(this.flyoutTimer)
      this.show = true
    },
    closeFlyout() {
      clearTimeout(this.flyoutTimer)
      this.flyoutTimer = setTimeout(() => {
        this.show = false
      }, FLYOUT_CLOSE_DELAY)
    }
  },
  computed: {
    isFlyout() {
      return this.flyout && this.clientWidth >= FLYOUT_MIN_WIDTH
    }
  },
  watch: {
    isFlyout() {
      this.show = false
    }
  },
  components: {
    MenuItem,
    CollapseBlock
  },
  beforeDestroy() {
    clearTimeout(this.flyoutTimer)
  },
  props: {
    label: {
      type: String
    },
    dataQa: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    icon: {
      type: String
    },
    iconColor: {
      type: String
    },
    menuItemClass: {
      type: String,
      default: 'h7-text-medium pl-3'
    },
    /**
     * На екранах ширших за планшет підменю відкривається вліво поруч із меню, а не гармошкою
     */
    flyout: {
      type: Boolean
    }
  }
}
</script>
<style scoped lang="scss">
.menu-collapse,
.menu-flyout {
  &.is-open {
    background: rgba(var(--color-main-green-rgba), 0.75);
  }
}
.menu-collapse__item {
  display: grid;
  transition: 0.25s all;
  grid-template-columns: auto 30px;
  cursor: pointer;
  &:focus,
  &:hover {
    background: var(--color-main-green);
  }
}
.menu-flyout {
  position: relative;
  &__submenu {
    position: absolute;
    top: var(--menu-flyout-top, -2px);
    right: calc(100% + var(--menu-flyout-gap, 2px));
    width: 330px;
    max-height: calc(100vh - 80px);
    overflow-y: auto;
    border: var(--menu-flyout-border, 2px solid var(--v-main__green-base));
    border-radius: 4px 0 4px 4px;
    background-color: var(--menu-flyout-bg, var(--v-secondary__green_chosen-base));
    box-shadow: 0 2px 12px 0 rgba(var(--black-color-rgba), .1);
  }
}
</style>
